<template>
    <div class="af-account-settings">
        <PageHeading>{{ $t('dashboard_menu.account_settings') }}</PageHeading>

        <template v-if="!$_seekerFieldByCode('change_email').is_hidden">
            <SettingUpdateEmail />
        </template>

        <template v-if="!$_seekerFieldByCode('reset_password').is_hidden">
            <SettingUpdatePassword />
        </template>
        <template v-if="!$_seekerFieldByCode('delete_account').is_hidden">
            <SettingDeleteAccount />
        </template>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import has from 'lodash/has';
    import PageHeading from '@/apps/dashboard/001/components/PageHeading';
    import SettingUpdateEmail from '@/apps/dashboard/001/components/Settings/SettingUpdateEmail';
    import SettingDeleteAccount from '@/apps/dashboard/001/components/Settings/SettingDeleteAccount';
    import SettingUpdatePassword from '@/apps/dashboard/001/components/Settings/SettingUpdatePassword';

    export default {
        name: 'AccountSettings',

        layout: 'settings',

        components: {
            PageHeading,
            SettingUpdateEmail,
            SettingDeleteAccount,
            SettingUpdatePassword,
        },

        data() {
            return {
                subscriptionsTypes: [],
            };
        },

        async created() {
            const [subsTypes, subscriptions] = await Promise.all([
                this.$_getSubscriptionTypes().then(response => response.data),
                this.$_getSubscriptions().then(response => response.data),
            ]);
            this.subscriptionsTypes = subsTypes.map(o => {
                const userSubscription = subscriptions.find(
                    j =>
                        has(j, 'subscriptionType.id') &&
                        j.subscriptionType.id === o.id,
                );

                return {
                    ...o,
                    is_active:
                        !!userSubscription &&
                        !!userSubscription.id &&
                        !!userSubscription.is_active,
                };
            });
        },

        computed: {
            ...mapGetters('site', {
                $_seekerFieldByCode: 'seekerFieldByCode',
            }),
        },

        methods: {
            ...mapActions('common', {
                $_getSubscriptionTypes: 'getSubscriptionTypes',
            }),

            ...mapActions('me', {
                $_getSubscriptions: 'getSubscriptions',
            }),
        },
    };
</script>
